import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
const ROLES = ["Viewer", "Field", "Manager", "Admin"];

export function AuthProvider({ children }) {
  const [me, setMe] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setMe(r.data);
      localStorage.setItem("pc-me", JSON.stringify(r.data));
    } catch (e) {
      const cached = !e.response && localStorage.getItem("pc-me");
      setMe(cached ? JSON.parse(cached) : null);
    }
  }, []);

  useEffect(() => {
    // Skip while returning from OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) { setMe(null); return; }
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("pc-me");
    setMe(null);
  };

  const switchOrg = async (org_id) => {
    const r = await api.post("/auth/switch-org", { org_id });
    setMe(r.data);
  };

  const can = (min) => !!me?.role && ROLES.indexOf(me.role) >= ROLES.indexOf(min);

  return <AuthCtx.Provider value={{ me, setMe, refresh, logout, switchOrg, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
